import { DesiredTelehealthExperience } from '~Data';

export const desiredTelehealthExperienceChoices: {
  [key in DesiredTelehealthExperience]: string;
} = {
  [DesiredTelehealthExperience.OpenToAny]: `I'm open to candidates regardless of previous telehealth experience`,
  [DesiredTelehealthExperience.HasPreviousExperience]:
    'Only show me candidates with previous telehealth experience',
};
